define('OutSystems/ReactView/BaseNavigationCallbacks',["require", "exports", "query-string", "./Root"], function (require, exports, queryString, Root_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BaseNavigationCallbacks = (function () {
        function BaseNavigationCallbacks(currentHistory, currentRuntime) {
            this.currentHistory = currentHistory;
            this.currentRuntime = currentRuntime;
        }
        BaseNavigationCallbacks.urlToLocationDescriptor = function (urlInfo, transition) {
            return {
                pathname: urlInfo.path,
                search: queryString.stringify(urlInfo.queryParams),
                state: {
                    transition: transition,
                },
                hash: urlInfo.hash ? "#" + urlInfo.hash : "",
            };
        };
        BaseNavigationCallbacks.prototype.push = function (location) {
            this.currentHistory.push(location);
        };
        BaseNavigationCallbacks.prototype.replace = function (location) {
            this.currentHistory.replace(location);
        };
        BaseNavigationCallbacks.prototype.goTo = function (urlInfo, transition, replace) {
            var location = BaseNavigationCallbacks.urlToLocationDescriptor(urlInfo, transition);
            if (replace || this.currentRuntime.isShowingSplashScreen) {
                this.replace(location);
            }
            else {
                this.push(location);
            }
        };
        BaseNavigationCallbacks.prototype.goOffset = function (offset, transition) {
            if (transition) {
                Root_1.default.transitionOverride = transition;
            }
            this.currentHistory.go(offset);
        };
        BaseNavigationCallbacks.prototype.goBack = function (transition) {
            if (transition) {
                Root_1.default.transitionOverride = transition;
            }
            this.currentHistory.goBack();
        };
        BaseNavigationCallbacks.prototype.goForward = function (transition) {
            if (transition) {
                Root_1.default.transitionOverride = transition;
            }
            this.currentHistory.goForward();
        };
        BaseNavigationCallbacks.prototype.dispose = function (_) { };
        return BaseNavigationCallbacks;
    }());
    exports.default = BaseNavigationCallbacks;
});
//# sourceMappingURL=BaseNavigationCallbacks.js.map;
